import { Divider } from '@chakra-ui/react';
import CustomStepper from 'components/ui/custom-stepper/CustomStepper';
import StepperProvider from 'components/ui/custom-stepper/CustomStepperContext';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { CONTENT_GROUP_TYPE_NAMES } from 'features/content-groups/components/ContentGroupsList';
import { useContentGroup } from 'features/content-groups/hooks/useContentGroup';
import { useParams } from 'react-router-dom';
import { wrapperDialogDefaultProps } from '../config';
import CreateContent from '../forms/FormContent';

export default function PageCreateEmail() {
  const { id } = useParams();
  const { data: contentGroup } = useContentGroup(id);

  return (
    <StepperProvider
      steps={['Conteúdo', 'Listas', 'Conferir dados']}
    >
      <HeaderBarInternal
        title={contentGroup ? `Novo disparo de ${CONTENT_GROUP_TYPE_NAMES[contentGroup.type]} - ${contentGroup.name}`: 'Novo disparo'}
        backTo={`/disparos-de-report/novo/${id}`}
        dialogProps={wrapperDialogDefaultProps}
      >
        <CustomStepper />
      </HeaderBarInternal>
      
      <Divider />
      
      <CreateContent />

    </StepperProvider>
  )
}